import React from "react";
import Head from "next/head";

import InvitationMain from "@/components/invitation/invitation-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Invitation = () => {
  return (
    <>
      <Head>
        <title>{seoData.INVITATION.title}</title>
        <SeoMetaData data={seoData.INVITATION} />
      </Head>

      <InvitationMain />
    </>
  );
};

export default Invitation;
